import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccountComponent } from './components/account/account.component';
import { AfterChangeEmailComponent } from './components/after-change-email/after-change-email.component';
import { addressBookRoutes } from './modules/address-book/address-book-routing.module';
import { accountManagementRoutes } from './modules/account-management/account-management-routing.module';
import { EmployeeRedirectionPromptGuard } from '~app/core/guards/employee-redirection-prompt.guard';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';


const accountRoutes: Routes = [
  {
    path: 'after-change-email',
    component: AfterChangeEmailComponent,
    data: { title: 'TITLE.PAGE.ACCOUNT.AFTER_CHANGE_EMAIL' },
  },
  {
    path: '',
    component: AccountComponent,
    children: [
      {
        path: 'info',
        children: accountManagementRoutes,
        data: { title: 'TITLE.PAGE.ACCOUNT.INFO' },
      },
      {
        path: 'address-book',
        children: addressBookRoutes,
        data: { title: 'TITLE.PAGE.ACCOUNT.ADDRESS_BOOK' },
      },
      {
        path: 'orders-history',
        loadChildren: () => import('./modules/orders-history/orders-history.module')
          .then((m) => m.OrdersHistoryModule),
        data: { title: 'TITLE.PAGE.ACCOUNT.ORDERS_HISTORY' },
        canDeactivate: [EmployeeRedirectionPromptGuard]
      },
      {
        path: 'buy-again',
        loadChildren: () => import('./modules/buy-again/buy-again.module')
          .then((m) => m.BuyAgainModule),
        data: { title: 'TITLE.PAGE.ACCOUNT.BUY_AGAIN' },
      },
      {
        path: 'shopping-list',
        redirectTo:'your-assortment'
      },
      {
        path: 'your-assortment',
        loadChildren: () => import('./modules/your-assortment/your-assortment.module')
          .then((m) => m.YourAssortmentModule),
        data: { title: 'TITLE.PAGE.ACCOUNT.SHOPPING_LIST' },
      },
      {
        path: 'stored-payment-methods',
        loadChildren: () => import('./modules/stored-payment-methods/stored-payment-methods.module')
          .then((m) => m.StoredPaymentMethodsModule),
        data: { title: 'TITLE.PAGE.ACCOUNT.PAYMENT_METHODS' },
      },
      {
        path: 'access-denied',
        component: AccessDeniedComponent,
        data: { title: 'ERROR.401_PAGE.TITLE'}
      },
      {
        path: '**',
        redirectTo: 'info',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(accountRoutes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
